import React from 'react';
import './App.css';
import Index1 from './component/Index1'


function App() {
  return (
    <>
      <Index1 />
    </>
  );
}

export default App;
